module.exports = __webpack_public_path__ + "img/ys_bj_6.6b7e0f43.png";